import { combineReducers } from 'redux'
import { routerReducer as routing } from 'react-router-redux'
import base from './baseReducer'
import user from './userReducer'
import common from './commonReducer'
import lottery from './lotteryReducer'
import game from './gameReducer'
import method from './methodReducer'
import report from './reportReducer'
import activity from './activityReducer'
import push from './pushReducer'
import dashboard from './dashboardReducer'

const rootReducer = combineReducers({
  routing,
  base,
  user,
  common,
  lottery,
  game,
  method,
  activity,
  report,
  dashboard,
  push
})

export default rootReducer
